import React from 'react';
import PropTypes from 'prop-types';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const ReactTableBody = ({
  tableBodyProps,
  page,
  prepareRow,
  onCellClick,
  classes,
}) => {
  return (
    <>
      <TableBody className={classes.odd} {...tableBodyProps}>
        {page.map((row) => {
          prepareRow(row);
          return (
            <TableRow className={classes.tableRow} {...row.getRowProps()}>
              {row.cells.map((cell) => {
                return (
                  <TableCell
                    {...cell.getCellProps({
                      onClick: (e) => {
                        onCellClick(e, cell.row.original, cell.column.id);
                      },
                    })}
                    className={classes.tableCell}
                  >
                    {cell.render('Cell')}
                  </TableCell>
                );
              })}
            </TableRow>
          );
        })}
      </TableBody>
    </>
  );
};

ReactTableBody.defaultProps = {
  classes: {},
};

ReactTableBody.propTypes = {
  tableBodyProps: PropTypes.any.isRequired,
  page: PropTypes.any.isRequired,
  prepareRow: PropTypes.func.isRequired,
  onCellClick: PropTypes.func.isRequired,
  classes: PropTypes.any,
};

export default ReactTableBody;
